var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('start-layer', {
    attrs: {
      "clip-waves-class": "white text-body-1",
      "offset": .9
    }
  }, [_c('h3', {
    staticClass: "mb-3 text-left"
  }, [_vm._v("Start")]), _c('v-list', {
    staticClass: "my-0 px-0 transparent li-grid",
    attrs: {
      "dense": ""
    }
  }, _vm._l(_vm.ACTIONS, function (_ref) {
    var to = _ref[0],
      title = _ref[1],
      icon = _ref[2];
    return _c('v-list-item', {
      key: title,
      staticClass: "li-pop ec-dark-blue--text",
      attrs: {
        "exact": "",
        "to": to
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      },
      domProps: {
        "innerHTML": _vm._s(icon)
      }
    }), _c('div', {
      domProps: {
        "innerHTML": _vm._s(title)
      }
    }), _c('v-icon', {
      attrs: {
        "small": ""
      },
      domProps: {
        "innerHTML": _vm._s(_vm.mdiChevronRight)
      }
    })], 1);
  }), 1), _c('h3', {
    staticClass: "mb-3 text-left"
  }, [_vm._v("Products / features")]), _c('v-list', {
    staticClass: "my-0 px-0 transparent li-grid",
    attrs: {
      "dense": ""
    }
  }, _vm._l(_vm.SECTIONS, function (header) {
    return _c('v-list-item', {
      key: header.name,
      staticClass: "li-pop ec-dark-blue--text",
      attrs: {
        "exact": "",
        "to": {
          name: _vm.getRouteName(header.name)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      },
      domProps: {
        "innerHTML": _vm._s(header.icon)
      }
    }), _c('div', [_vm._v(_vm._s(header.nameLong || header.name))]), _c('v-icon', {
      attrs: {
        "small": ""
      },
      domProps: {
        "innerHTML": _vm._s(_vm.mdiChevronRight)
      }
    })], 1);
  }), 1), _c('h3', {
    staticClass: "mb-3 text-left"
  }, [_vm._v("More information")]), _c('v-list', {
    staticClass: "mt-0 mb-16 px-0 transparent li-grid",
    attrs: {
      "dense": ""
    }
  }, _vm._l([[{
    name: 'pricing'
  }, 'Pricing', _vm.mdiCurrencyUsd], [{
    name: 'faq'
  }, 'FAQ', _vm.mdiFrequentlyAskedQuestions], [{
    name: 'blog'
  }, 'Blog', _vm.mdiFormatFloatLeft]], function (_ref2) {
    var to = _ref2[0],
      title = _ref2[1],
      icon = _ref2[2];
    return _c('v-list-item', {
      key: title,
      staticClass: "li-pop ec-dark-blue--text",
      attrs: {
        "exact": "",
        "to": to
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      },
      domProps: {
        "innerHTML": _vm._s(icon)
      }
    }), _c('div', {
      staticClass: "flex-grow-1"
    }, [_vm._v(_vm._s(title))]), _c('v-icon', {
      attrs: {
        "small": ""
      },
      domProps: {
        "innerHTML": _vm._s(_vm.mdiChevronRight)
      }
    })], 1);
  }), 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }